import { makeApiCall } from "@swiggy-private/js-utils";
import { API_ENDPOINTS, DINEOUT_PARTNER_API_HOST } from "../constants/api";
import { IDigitalMenuConfigRequest, IDigitalMenuConfigResponse } from "../types/config";
import { customApiCall, IOptions } from "../utils/api";

export const fetchDigitalMenuConfig = async (params: IDigitalMenuConfigRequest, _makeApiCall: typeof makeApiCall) => {
    const { restaurantId } = params;

    const options: IOptions = {
        searchParams: {
            restaurantId,
        },
        method: "GET",
    };

    const response = await customApiCall<IDigitalMenuConfigResponse>({
        _makeApiCall,
        apiHost: DINEOUT_PARTNER_API_HOST,
        apiEndpoint: API_ENDPOINTS.DIGITAL_MENU_CONFIG,
        opts: options,
    });

    return response;
};
